import axios from "axios";
import router from "@/router/index";
import store from "../state/store";
import { decodeJwtTokenPayload } from "../helpers/jwtHelper";
import { shiftAuthTypeToTmp } from "@/helpers/authTypeHelper";

function getErrorCode(error) {
  return error?.response?.data?.code || null;
}

function getAuthTypeFromToken() {
  const token = localStorage.getItem("token");
  if (!token) return null;
  try {
    return decodeJwtTokenPayload(token).AuthType || null;
  } catch {
    return null;
  }
}

function redirectToLogin(authType) {
  const effectiveAuthType = authType || localStorage.getItem("lastAuthType");

  if (effectiveAuthType) {
    shiftAuthTypeToTmp(effectiveAuthType);
  }

  if (effectiveAuthType === "OTP") {
    router.push({ name: "GuestLogin" });
  } else if (effectiveAuthType === "SAML") {
    const backendBaseUrl = process.env.VUE_APP_BACKEND_URL;
    window.location.replace(
      `${backendBaseUrl}/api/Identity/Auth/Login?returnUrl=${backendBaseUrl}/api/Identity/Auth/AssertionConsumerService`
    );
  } else {
    router.push({ name: "LoginLanding" });
  }
}

export default class AxiosBase {
  constructor() {
    axios.interceptors.response.use(
      (response) => response,
      async function (error) {
        const status = error?.response?.status;
        const errorCode = getErrorCode(error);
        const token = localStorage.getItem("token");
        const authType = getAuthTypeFromToken();
        const isPublicRequest = error?.config?.url?.includes("/api/Public/");

        // Token yoksa → login'e yönlendir
        if (!token && !isPublicRequest) {
          // Backend X-Auth-Types-For-Redirect header'ı varsa onu kullan
          const headerAuthType = error?.response?.headers?.["x-auth-types-for-redirect"];
          redirectToLogin(headerAuthType || null);
          return Promise.reject(error);
        }

        // OTP kullanıcısı auth hatası aldığında → guest login callback
        if (authType === "OTP" && status === 401) {
          router.push({ name: "GuestLoginCallback" });
          return Promise.reject(error);
        }

        if (status === 401) {
          const headerAuthType = error?.response?.headers?.["x-auth-types-for-redirect"];
          if (["TOKEN_EXPIRED", "TOKEN_INVALID", "TOKEN_MISSING"].includes(errorCode) || !errorCode) {
            redirectToLogin(headerAuthType || authType || null);
            localStorage.removeItem("token");
            return Promise.reject(error);
          }

          redirectToLogin(headerAuthType || authType || null);
          return Promise.reject(error);
        }

        if (status === 403) {
          router.push({ name: "error-403" });
          return Promise.reject(error);
        }

        return Promise.reject(error);
      }
    );

    axios.interceptors.request.use(function (config) {
      let token = localStorage.getItem("token");
      config.headers.Authorization = `Bearer ${token}`;
      if (config.headers["Content-Type"] == undefined) config.headers["Content-Type"] = "application/json";
      config.headers["Referrer"] = router.currentRoute.fullPath;
      let language = localStorage.getItem("language") || "tr";
      config.headers["Accept-Language"] = language;

      if (!config.url.includes("GenerateRefreshToken")) {
        store.dispatch("sessionTimer/reset");
      } else {
        store.dispatch("tokenRefresh/reset");
      }

      return config;
    });
  }
}
